import ApiService from "@/core/services/api.service";

const actions = {
  /**
   * Delete staff in facial device
   * @param context
   * @param payload
   * @returns {*}
   */
  deleteStaffFacialDevice(context, payload) {
    console.log(payload);
    ApiService.setHeader();
    return ApiService.post("school/device/facial/staff/delete", payload).then(
      (response) => response
    );
  },
};

export default {
  actions,
};
